import { stateSetter } from '@/utils';
import { IServerColumnConfig } from '@/components/table/column-config';

// Culoarea unui stagiu e un string liber din BE (nume legacy sau HEX). O rezolvăm mereu la HEX.
export interface StatusColorPreset {
	hex: string;
	label: string;
}

export const STATUS_COLOR_PRESETS: StatusColorPreset[] = [
	{ hex: '#f5222d', label: 'Roșu' },
	{ hex: '#fa8c16', label: 'Portocaliu' },
	{ hex: '#fadb14', label: 'Galben' },
	{ hex: '#52c41a', label: 'Verde' },
	{ hex: '#1890ff', label: 'Albastru' },
	{ hex: '#722ed1', label: 'Mov' },
	{ hex: '#8c8c8c', label: 'Gri' }
];

const FALLBACK_HEX = '#8c8c8c';

// Nume RO legacy → HEX (BE returna „Roșu" / „Portocaliu" / „Verde" înainte de trecerea la HEX).
const NAME_TO_HEX: Record<string, string> = {
	roșu: '#f5222d',
	rosu: '#f5222d',
	portocaliu: '#fa8c16',
	galben: '#fadb14',
	verde: '#52c41a',
	albastru: '#1890ff',
	mov: '#722ed1',
	gri: '#8c8c8c'
};

const HEX_RE = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

// Rezolvă orice valoare de culoare (HEX sau nume) la un HEX afișabil.
export const resolveStatusColor = (color?: string): string => {
	if (!color) return FALLBACK_HEX;
	const value = color.trim();
	if (HEX_RE.test(value)) return value;
	return NAME_TO_HEX[value.toLowerCase()] ?? FALLBACK_HEX;
};

export interface IProjectStatus {
	id: number | string;
	name: string;
	color?: string;
	// `default` în BE — stagiul aplicat automat proiectelor noi.
	isDefault?: boolean;
	position?: number;
	description?: string | null;
	createdAt?: string;
}

// Payload create/edit — aliniat la BE (name + color HEX + default + description).
export interface IProjectStatusPayload {
	name: string;
	color?: string;
	isDefault?: boolean;
	description?: string;
}

export interface ProjectStatusesReturnType {
	data: IProjectStatus[];
	setData: stateSetter<IProjectStatus[]>;
	loading: boolean;
	/** Config-ul de coloane din BE (api/project-stages/table-config); null → coloanele locale. */
	tableConfig: IServerColumnConfig[] | null;
	loadingTableConfig: boolean;
	loadingCreate: boolean;
	loadingUpdate: boolean;
	loadingDelete: boolean;
	getStatuses: (pageParam: number, itemsParam: number) => Promise<void>;
	getStatusesQuery: (
		queryParam: string,
		pageParam: number,
		itemsParam: number
	) => Promise<void>;
	createStatus: (payload: IProjectStatusPayload, onSuccess?: () => void) => Promise<void>;
	editStatus: (
		statusId: number | string,
		payload: IProjectStatusPayload,
		onSuccess?: () => void
	) => Promise<void>;
	removeStatus: (statusId: number | string, onSuccess?: () => void) => Promise<void>;
	page: number;
	items: number;
	setPage: stateSetter<number>;
	setItems: stateSetter<number>;
	totalPages: number;
	totalItems: number;
}
